import styled from "styled-components";

export const WideContainerWithTopBar = styled.div`
	padding: 2rem;
	width: 100%;
	height: 100%;
	max-height: calc(100vh - 75px);
	overflow: auto;
	@media only screen and (max-width: 1024px) {
		max-height: calc(100vh - 230px);
	}

	/* =========================
   ANDROID / OTHER TABLET
   (16:10, 16:9) — PORTRAIT
   ========================= */

	/* Small portrait ~ 720×1080 (16:9) */
	@media (orientation: portrait) and (pointer: coarse) and (hover: none) and (min-width: 700px) and (max-width: 760px) {
		max-height: calc(100vh - 210px);
	}

	/* Medium portrait ~ 800×1280 (16:10) */
	@media (orientation: portrait) and (pointer: coarse) and (hover: none) and (min-width: 761px) and (max-width: 860px) {
		max-height: calc(100vh - 220px);
	}

	/* Large/high-res portrait (1000–1300) */
	@media (orientation: portrait) and (pointer: coarse) and (hover: none) and (min-width: 861px) and (max-width: 1300px) {
		max-height: calc(100vh - 230px);
	}

	/* Tablet landscape */
	@media (orientation: landscape) and (pointer: coarse) and (hover: none) and (min-height: 600px) and (max-height: 834px) {
		padding: 1rem;
		max-height: calc(100vh - 250px);
	}

	@media (orientation: landscape) and (pointer: coarse) and (hover: none) and (max-width: 1366px) {
		padding: 1rem;
		max-height: calc(100vh - 270px);
	}
	/* Ipad landscape */

	@media (max-width: 1194px) and (pointer: coarse) and (hover: none) and (max-aspect-ratio: 4/3) {
		padding: 1rem;
		max-height: calc(100vh - 250px);
	}
	@media (orientation: landscape) and (pointer: coarse) and (hover: none) and (max-width: 1366px) {
		padding: 1rem;
		max-height: calc(100vh - 270px);
	}

	/* Ipad Portrait */

	@media (orientation: portrait) and (aspect-ratio: 4/3) and (pointer: coarse) and (hover: none) and (min-width: 768px) and (max-width: 834px) {
		max-height: calc(100vh - 220px);
	}
	@media (min-width: 835px) and (pointer: coarse) and (hover: none) (max-width: 1024px) and (max-aspect-ratio: 4/3) {
		padding: 1rem;
		max-height: calc(100vh - 230px);
	}

	/* Smartphone */

	@media only screen and (max-width: 600px) {
		padding: 10px;
		max-height: calc(100vh - 190px);
	}
`;
